export enum SortDirectionStoreModelEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}
